export default "__VITE_ASSET__CrBpYje1__"